export default "__VITE_ASSET__6201895f__"